import { privateHttp } from "~/config/axios";
import { API_ENDPOINTS } from "~/config/endpoints";
import { useQuery } from "@tanstack/react-query";

export interface ReservType {
  key: string;
  value: string;
}

export const BUSINESS_CALENDAR_QUERY_KEYS = {
  reservTypeList: ["business", "reserve", "reservType-list"],
} as const;

// 예약 타입 리스트 조회 함수
const getReservTypeList = async (): Promise<ReservType[]> => {
  try {
    const { data } = await privateHttp.get(
      API_ENDPOINTS.BUSINESS_RESERVE.RESERV_TYPE_LIST
    );
    return data.data || [];
  } catch (error) {
    console.error("예약 타입 리스트 조회 실패:", error);
    throw error;
  }
};

// 예약 타입 리스트 useQuery hook
export const useReservTypeList = () => {
  return useQuery({
    queryKey: BUSINESS_CALENDAR_QUERY_KEYS.reservTypeList,
    queryFn: getReservTypeList,
    staleTime: 1000 * 60 * 5, // 5분
    gcTime: 1000 * 60 * 10, // 10분
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
